import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';

/**
 * Tabbed shell over the Brand Manager list views. Tabs are routed links so the
 * active tab is reflected in the URL (deep-linkable, back-button safe). Detail
 * sub-pages (brand form, number blocks, brand domains) render outside this
 * shell with their own breadcrumb header.
 */
@Component({
  selector: 'cmt-admin-shell',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterLink, RouterLinkActive, RouterOutlet],
  template: `
    <div class="flex flex-col gap-4 p-4 sm:p-6">
      <nav class="flex items-center gap-1 border-b border-border" role="tablist">
        <a
          role="tab"
          routerLink="/admin/brands"
          routerLinkActive="border-primary text-foreground"
          [routerLinkActiveOptions]="{ exact: true }"
          class="cmt-eyebrow -mb-px border-b-2 border-transparent px-4 py-2.5 text-muted-foreground transition-colors hover:text-foreground"
        >Brands</a>
        <a
          role="tab"
          routerLink="/admin/domains"
          routerLinkActive="border-primary text-foreground"
          [routerLinkActiveOptions]="{ exact: true }"
          class="cmt-eyebrow -mb-px border-b-2 border-transparent px-4 py-2.5 text-muted-foreground transition-colors hover:text-foreground"
        >Domains</a>
      </nav>
      <router-outlet />
    </div>
  `,
})
export class AdminShellComponent {}
